<template>
  <div class="detailBox">
    <!-- 可编辑的基础信息 - 页面头部直接显示 -->
    <div class="baseInfoSection">
      <div class="baseInfoHeader">
        <h3 class="sectionTitle">酒店基础信息</h3>
        <el-button
          type="primary"
          @click="onSubmit()"
          :loading="state.saving"
          :icon="Check"
        >
          保存基础信息
        </el-button>
      </div>
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        class="baseInfoForm"
      >
        <div class="formGrid">
          <el-form-item
            label="状态"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择启用状态', trigger: 'blur' },
            ]"
          >
            <el-switch
              v-model="state.model.IsQy"
              inline-prompt
              active-text="可售"
              inactive-text="停用"
            />
          </el-form-item>
          <el-form-item
            label="供应商"
            prop="GysId"
            :rules="[
              { required: true, message: '请选择供应商', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.GysId"
              placeholder="请选择供应商"
              :disabled="!Array.isArray(state.gysData)"
            >
              <el-option
                v-for="item in state.gysData"
                :key="item.Id"
                :label="item.Mc"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="酒店名称"
            prop="Mc"
            :rules="[
              { required: true, message: '请输入酒店名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.Mc" />
          </el-form-item>
          <el-form-item
            label="星级"
            prop="Xj"
            :rules="[
              { required: true, message: '请选择星级', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.Xj" placeholder="请选择星级">
              <el-option label="三星" value="三星" />
              <el-option label="四星" value="四星" />
              <el-option label="五星" value="五星" />
              <el-option label="经济型" value="经济型" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="Dh"
            :rules="[
              { required: true, message: '请输入联系电话', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.Dh" />
          </el-form-item>
          <el-form-item
            label="房间数"
            prop="Fjs"
            :rules="[
              { required: true, message: '请输入房间数', trigger: 'blur' },
            ]"
          >
            <el-input-number
              v-model="state.model.Fjs"
              :min="1"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="地址" class="formItemFull">
            <el-input v-model="state.model.Dz" />
          </el-form-item>
          <el-form-item label="经度" prop="Jd">
            <el-input v-model="state.model.Jd" placeholder="116.404" />
          </el-form-item>
          <el-form-item label="纬度" prop="Wd">
            <el-input v-model="state.model.Wd" placeholder="39.915" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="text"
              @click="openMapModal()"
              style="padding: 0; color: #007bff"
            >
              🗺️ 坐标拾取
            </el-button>
          </el-form-item>
          <el-form-item label="早餐" prop="Zc">
            <el-select v-model="state.model.Zc" placeholder="请选择">
              <el-option label="无" value="无" />
              <el-option label="含早" value="含早" />
              <el-option label="单早" value="单早" />
              <el-option label="双早" value="双早" />
            </el-select>
          </el-form-item>
          <el-form-item label="入住时间" prop="Rzsj">
            <el-time-picker
              v-model="state.model.Rzsj"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="退房时间" prop="Tfsj">
            <el-time-picker
              v-model="state.model.Tfsj"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="可预订日期">
            <el-date-picker
              v-model="state.model.Kydyrq"
              type="daterange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              value-format="YYYY-MM-DD"
              style="width: 100%"
            />
          </el-form-item>
          <div class="formItemGroup">
            <el-form-item label="是否需要预约" class="formItemYuyue">
              <el-switch
                v-model="state.model.IsYuyue"
                inline-prompt
                active-text="是"
                inactive-text="否"
              />
            </el-form-item>
            <el-form-item label="提前预约天数" v-if="state.model.IsYuyue" class="formItemYuyueTianShu">
              <el-input-number
                v-model="state.model.YuyueTianShu"
                :min="1"
                controls-position="right"
                placeholder="需提前N天预约"
              />
            </el-form-item>
          </div>

          <el-form-item label="核销码类型" prop="HeXiaoMaLeiXing">
            <el-select v-model="state.model.HeXiaoMaLeiXing" placeholder="请选择">
              <el-option label="无" :value="0" />
              <el-option label="系统自动码" :value="1" />
            </el-select>
          </el-form-item>
        </div>

        <div class="formGrid">
          <el-form-item label="酒店设施" class="formItemFull">
            <el-checkbox-group v-model="state.model.Ss">
              <el-checkbox label="WiFi" />
              <el-checkbox label="停车场" />
              <el-checkbox label="健身房" />
              <el-checkbox label="游泳池" />
              <el-checkbox label="会议室" />
              <el-checkbox label="餐厅" />
              <el-checkbox label="商务中心" />
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- Tab区域：酒店简介 + 预订须知 + 酒店图片 + 套餐管理 + 销售控制 -->
    <div class="tabSection">
      <el-tabs v-model="state.activeTab" :before-leave="onTabsChange">
        <el-tab-pane lazy label="酒店简介" name="jianjie">
          <el-input
            type="textarea"
            v-model="state.model.Jj"
            :autosize="{ minRows: 6 }"
            placeholder="请输入酒店简介"
          />
        </el-tab-pane>
        <el-tab-pane lazy label="使用须知" name="xuzhi">
          <div class="notice-editor">
            <!-- 入离说明 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Clock /></el-icon>
                <span>入离说明</span>
              </div>
              <el-input
                type="textarea"
                v-model="notice['入离说明']"
                :autosize="{ minRows: 4 }"
                placeholder="例如：\n• 最早入住时间15:00，最晚离店时间12:00\n• 入住方式：前台领取钥匙/门卡-住宿外"
              />
            </div>

            <!-- 加价规则 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Money /></el-icon>
                <span>加价规则</span>
                <el-button type="primary" size="small" :icon="Plus" @click="addNoticeRow('加价规则')">添加</el-button>
              </div>
              <el-table :data="notice['加价规则']" border size="small" style="width: 100%">
                <el-table-column label="加价日期" min-width="220">
                  <template #default="scope">
                    <el-input v-model="scope.row['加价日期']" placeholder="例如：2026.04.30-04.30" />
                  </template>
                </el-table-column>
                <el-table-column label="加价金额" min-width="180">
                  <template #default="scope">
                    <el-input v-model="scope.row['加价金额']" placeholder="例如：100元/间/晚" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template #default="scope">
                    <el-button type="danger" link size="small" :icon="Delete" @click="removeNoticeRow('加价规则', scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="notice['加价规则'].length === 0" class="notice-empty">暂无加价规则，点击“添加”按钮新增</div>
            </div>

            <!-- 费用须知 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Wallet /></el-icon>
                <span>费用须知</span>
                <el-button type="primary" size="small" :icon="Plus" @click="addNoticeRow('费用须知')">添加</el-button>
              </div>
              <el-table :data="notice['费用须知']" border size="small" style="width: 100%">
                <el-table-column label="费用项" min-width="220">
                  <template #default="scope">
                    <el-input v-model="scope.row['费用项']" placeholder="例如：儿童1.2m以上早餐费用" />
                  </template>
                </el-table-column>
                <el-table-column label="费用内容" min-width="180">
                  <template #default="scope">
                    <el-input v-model="scope.row['费用内容']" placeholder="例如：1份收费68元" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template #default="scope">
                    <el-button type="danger" link size="small" :icon="Delete" @click="removeNoticeRow('费用须知', scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="notice['费用须知'].length === 0" class="notice-empty">暂无费用须知，点击“添加”按钮新增</div>
            </div>

            <!-- 预约规则 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Calendar /></el-icon>
                <span>预约规则</span>
              </div>
              <el-input
                type="textarea"
                v-model="notice['预约规则']"
                :autosize="{ minRows: 4 }"
                placeholder="例如：\n• 支持分次预约，每次按需选择入住时间、房型"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane lazy label="酒店图片" name="tupian">
          <el-form-item
            label=""
            style="width: 99%; display: flex; align-items: flex-start"
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px">
              <div
                v-for="(tp, index) in state.model.Tps"
                :key="tp"
                :style="{
                  marginTop: '10px',
                  marginRight: '10px',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  position: 'relative',
                  border:
                    state.model.Fm === tp
                      ? '3px solid #409eff'
                      : '3px solid transparent',
                  boxSizing: 'border-box',
                }"
                class="uploadTpBox"
              >
                <img class="uploadTp" :src="getImageUrl(tp)" referrerpolicy="no-referrer" />
                <div
                  style="text-align: center; padding: 8px; background: #f5f7fa"
                >
                  <el-radio-group
                    v-model="state.model.Fm"
                    style="display: flex; justify-content: center"
                  >
                    <el-radio :label="tp" size="small">设为封面</el-radio>
                  </el-radio-group>
                </div>
                <div class="uploadDel">
                  <div class="uploadActions">
                    <el-icon size="28" class="actionIcon" @click="onPreviewTp(index)"><View /></el-icon>
                    <el-icon size="28" class="actionIcon" @click="onDelTp(index)"><Delete /></el-icon>
                  </div>
                </div>
              </div>
            </div>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onUploadChange"
              style="marginleft: '10px'"
            >
              <template #trigger>
                <div class="uploadAdd">
                  <el-icon size="30" style="margin: auto; cursor: pointer"
                    ><Plus
                  /></el-icon>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <!-- 图片预览 -->
          <el-image-viewer
            v-if="state.preview.show"
            :url-list="state.preview.urlList"
            :initial-index="state.preview.index"
            :teleported="false"
            @close="closePreview"
          />
        </el-tab-pane>
        <el-tab-pane lazy label="套餐管理" name="taocan">
          <c_JiuDianTcList
            v-if="state.model.Id"
            :key="state.model.Id"
            :spId="state.model.Id"
          />
        </el-tab-pane>
        <el-tab-pane name="gz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              销售控制
            </text>
          </template>
          <c_JiuDianGzList
            v-if="state.model.Id"
            :spId="state.model.Id"
            :key="state.gzKey"
          ></c_JiuDianGzList>
        </el-tab-pane>
        <el-tab-pane name="lsgz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              历史销控
            </text>
          </template>
          <c_JiuDianGzOldList
            v-if="state.model.Id"
            :spId="state.model.Id"
            :key="state.lsgzKey"
          ></c_JiuDianGzOldList>
        </el-tab-pane>
        <el-tab-pane lazy label="评价信息" name="pingjia">
          <div class="pjWrap">
            <!-- 评价统计概览 -->
            <div class="pjSummary" v-if="state.pjSummary.totalCount > 0">
              <div class="pjScoreBox">
                <span class="pjScore">{{ state.pjSummary.avgRating }}</span>
                <span class="pjUnit">/5</span>
                <div class="pjStars">
                  <el-rate
                    v-model="state.pjSummary.avgRating"
                    disabled
                    show-score
                    text-color="#ff9900"
                  />
                </div>
                <span class="pjTotal"
                  >共 {{ state.pjSummary.totalCount }} 条评价</span
                >
              </div>
              <div class="pjDist">
                <div class="pjDistItem" v-for="i in 5" :key="i">
                  <span class="pjDistLabel">{{ 6 - i }}星</span>
                  <el-progress
                    :percentage="getRatingPercent(6 - i)"
                    :show-text="false"
                    :stroke-width="8"
                    color="#f5a623"
                  />
                  <span class="pjDistCount">{{ getRatingCount(6 - i) }}</span>
                </div>
              </div>
            </div>

            <!-- 评价列表 -->
            <div class="pjList">
              <div class="pjItem" v-for="pj in pagedPjList" :key="pj.Id">
                <div class="pjHeader">
                  <span class="pjUser">{{ pj.CjrXm }}</span>
                  <el-rate v-model="pj.Xj" disabled size="small" />
                  <span class="pjTime">{{ formatTime(pj.Cjsj) }}</span>
                </div>
                <div class="pjTags" v-if="pj.PjBq">
                  <el-tag
                    v-for="tag in pj.PjBq.split(',')"
                    :key="tag"
                    size="small"
                    type="info"
                    style="margin-right: 6px"
                    >{{ tag }}</el-tag
                  >
                </div>
                <div class="pjContent">{{ pj.PjNr }}</div>
                <div class="pjImages" v-if="pj.PjTp">
                  <el-image
                    v-for="(img, idx) in pj.PjTp.split(',')"
                    :key="idx"
                    :src="$http.defaults.baseURL + img"
                    :preview-src-list="
                      pj.PjTp.split(',').map((u) => $http.defaults.baseURL + u)
                    "
                    :initial-index="idx"
                    fit="cover"
                    class="pjImg"
                  />
                </div>
                <!-- 商家回复 -->
                <div class="pjReply" v-if="pj.HfNr">
                  <div class="pjReplyHeader">
                    <span class="pjReplyLabel">商家回复</span>
                    <span class="pjReplyTime">{{ formatTime(pj.HfSj) }}</span>
                  </div>
                  <div class="pjReplyContent">{{ pj.HfNr }}</div>
                </div>
              </div>

              <!-- 分页 -->
              <div
                class="pjPagination"
                v-if="state.pjList.length > state.pjPageSize"
              >
                <el-pagination
                  v-model:current-page="state.pjPageIndex"
                  :page-size="state.pjPageSize"
                  :total="state.pjList.length"
                  layout="total, prev, pager, next"
                  background
                  small
                />
              </div>

              <!-- 暂无评价 -->
              <div
                class="pjEmpty"
                v-if="state.pjLoaded && state.pjList.length === 0"
              >
                <el-empty description="暂无评价信息" />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  computed,
} from "vue";
import {
  Check,
  Clock,
  Delete,
  Plus,
  View,
} from "@element-plus/icons-vue";
import {
  jiudian_edit,
  jiudian_detail,
  jiudian_tc_list,
  jiudian_uploadtp,
  gongyingshang_select,
  shangpinpingjia_getbyspid,
  shangpinpingjia_getsummary,
  home_uploadconfig,
} from "@/http/api";
import $http from "@/http/index";
import { ElMessage } from "element-plus";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      saving: false,
      activeTab: "jianjie",
      model: {
        IsQy: true,
        Ss: [],
        Xj: "",
        Zc: "无",
        Tps: [],
        HeXiaoMaLeiXing: 0,
        SupplierGoodsId: "",
      },
      tcData: [],
      pjList: [],
      pjLoaded: false,
      pjPageIndex: 1,
      pjPageSize: 5,
      pjSummary: {
        totalCount: 0,
        avgRating: 0,
        ratingDistribution: { one: 0, two: 0, three: 0, four: 0, five: 0 },
      },
      imageBaseUrl: "", // 图片显示基础URL，根据后端配置决定
      preview: {
        show: false,
        urlList: [],
        index: 0,
      },
    });

    // 使用须知结构化数据（入离说明/加价规则/费用须知/预约规则）
    const notice = reactive({
      '入离说明': '',
      '加价规则': [],
      '费用须知': [],
      '预约规则': ''
    });

    // 解析使用须知 JSON（兼容旧数据纯文本）
    const parseNotice = (ydxz) => {
      if (!ydxz) {
        notice['入离说明'] = '';
        notice['加价规则'] = [];
        notice['费用须知'] = [];
        notice['预约规则'] = '';
        return;
      }
      try {
        const data = JSON.parse(ydxz);
        notice['入离说明'] = data['入离说明'] || '';
        notice['加价规则'] = Array.isArray(data['加价规则']) ? data['加价规则'] : [];
        notice['费用须知'] = Array.isArray(data['费用须知']) ? data['费用须知'] : [];
        notice['预约规则'] = data['预约规则'] || '';
      } catch {
        // 旧数据为纯文本，默认放入预约规则
        notice['入离说明'] = '';
        notice['加价规则'] = [];
        notice['费用须知'] = [];
        notice['预约规则'] = String(ydxz);
      }
    };

    // 序列化使用须知为 JSON
    const serializeNotice = () => {
      return JSON.stringify({
        '入离说明': notice['入离说明'],
        '加价规则': notice['加价规则'].filter(row => row['加价日期'] || row['加价金额']),
        '费用须知': notice['费用须知'].filter(row => row['费用项'] || row['费用内容']),
        '预约规则': notice['预约规则']
      });
    };

    const hotelId = computed(() => props.data?.id);

    //分页后的评价列表
    const pagedPjList = computed(() => {
      const start = (state.pjPageIndex - 1) * state.pjPageSize;
      return state.pjList.slice(start, start + state.pjPageSize);
    });

    onMounted(() => {
      loadUploadConfig();
      loadGys();
      if (hotelId.value) {
        loadDetail();
        onLoadTc();
      }
    });

    onUnmounted(() => {
      delete window.handleMapSelect;
      delete window.closeMapModal;
      if (window.mapModal) {
        window.mapModal.close();
        window.mapModal = null;
      }
    });

    //加载套餐数据
    const onLoadTc = () => {
      jiudian_tc_list(hotelId.value).then((res) => {
        if (res.status == 200) {
          state.tcData = res.data;
        }
      });
    };

    //选项卡切换事件
    const onTabsChange = (value) => {
      if (value == "gz") {
        // 切换前重新加载套餐数据，确保判断准确
        return jiudian_tc_list(hotelId.value).then((res) => {
          if (res.status == 200) {
            state.tcData = res.data;
          }
          if (state.tcData?.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请先添加酒店套餐！",
              grouping: true,
            });
            return false;
          }
          state.gzKey = Math.random();
        });
      } else if (value == "lsgz") {
        state.lsgzKey = Math.random();
      } else if (value == "pingjia") {
        state.pjPageIndex = 1;
        loadPingJia();
      }
    };

    //加载酒店详情
    const loadDetail = () => {
      jiudian_detail(hotelId.value).then((res) => {
        if (res.status == 200) {
          state.model = res.data;
          // 解析使用须知 JSON
          parseNotice(state.model.Ydxz);
          if (typeof state.model.Ss === "string") {
            state.model.Ss = state.model.Ss ? state.model.Ss.split(",") : [];
          }
          if (state.model.Kydyrq && typeof state.model.Kydyrq === "string") {
            state.model.Kydyrq = state.model.Kydyrq.split(",");
          }
          // Tps 可能是 JSON 字符串
          if (typeof state.model.Tps === 'string') {
            try {
              state.model.Tps = JSON.parse(state.model.Tps);
            } catch {
              state.model.Tps = [];
            }
          }
          if (!state.model.Tps) state.model.Tps = [];
          state.model.HeXiaoMaLeiXing = state.model.HeXiaoMaLeiXing ?? 0;
          state.model.SupplierGoodsId = state.model.SupplierGoodsId || "";
        }
      });
    };

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    //加载上传配置（OSS/本地）
    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status == 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            // 本地模式，使用API服务器地址
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        // 默认使用本地模式
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    //生成图片完整URL
    const getImageUrl = (tp) => {
      if (!tp) return "";
      // OSS返回的是完整URL（以http开头），直接使用
      if (tp.startsWith("http://") || tp.startsWith("https://")) {
        return tp;
      }
      // 本地相对路径，拼接baseUrl
      if (state.imageBaseUrl) {
        return state.imageBaseUrl + tp;
      }
      return $http.defaults.baseURL + tp;
    };

    //保存基础信息
    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.saving = true;
        const submitData = { ...state.model };
        // 序列化使用须知
        submitData.Ydxz = serializeNotice();
        if (Array.isArray(submitData.Ss)) {
          submitData.Ss = submitData.Ss.join(",");
        }
        if (Array.isArray(submitData.Kydyrq)) {
          submitData.Kydyrq = submitData.Kydyrq.join(",");
        }

        jiudian_edit(submitData)
          .then((res) => {
            if (res.status == 200) {
              proxy.$message.success("保存成功");
              loadDetail();
            }
          })
          .finally(() => {
            state.saving = false;
          });
      });
    };

    //上传图片
    const onUploadChange = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      jiudian_uploadtp(formData).then((res) => {
        if (res.status == 200) {
          state.model.Tps = [...state.model.Tps, ...res.data];
          if (!state.model.Fm) state.model.Fm = state.model.Tps[0];
        }
      });
    };

    //删除图片
    const onDelTp = (index) => {
      state.model.Tps.splice(index, 1);
      if (state.model.Fm) {
        if (state.model.Tps?.length > 0) {
          if (!state.model.Tps.includes(state.model.Fm)) {
            state.model.Fm = state.model.Tps[0];
          }
        } else {
          delete state.model.Fm;
        }
      }
    };

    // 图片预览
    const onPreviewTp = (index) => {
      state.preview.urlList = state.model.Tps.map((tp) => getImageUrl(tp));
      state.preview.index = index;
      state.preview.show = true;
    };

    const closePreview = () => {
      state.preview.show = false;
    };

    //打开坐标拾取弹框
    const openMapModal = () => {
      const lng = state.model.Jd || 117.251091;
      const lat = state.model.Wd || 31.51789;
      const url = `/map_picker.html?lng=${lng}&lat=${lat}`;

      const modalWidth = 850;
      const modalHeight = 680;
      const left = (window.screen.width - modalWidth) / 2;
      const top = (window.screen.height - modalHeight) / 2;

      window.mapModal = window.open(
        url,
        "_blank",
        `width=${modalWidth},height=${modalHeight},left=${left},top=${top},toolbar=no,scrollbars=no,resizable=yes`
      );

      window.handleMapSelect = (data) => {
        state.model.Jd = data.lng;
        state.model.Wd = data.lat;
        if (data.address) {
          state.model.Dz = data.address;
        }
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };

      window.closeMapModal = () => {
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
    };

    //加载评价信息
    const loadPingJia = () => {
      if (!hotelId.value) return;
      shangpinpingjia_getbyspid(hotelId.value).then((res) => {
        if (res.status == 200) {
          state.pjList = res.data || [];
          state.pjLoaded = true;
        }
      });
      shangpinpingjia_getsummary(hotelId.value).then((res) => {
        if (res.status == 200) {
          state.pjSummary = res.data;
        }
      });
    };

    //获取指定星级百分比
    const getRatingPercent = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const total = state.pjSummary?.totalCount;
      if (!dist || !total) return 0;
      const map = {
        1: dist.one,
        2: dist.two,
        3: dist.three,
        4: dist.four,
        5: dist.five,
      };
      return Math.round(((map[star] || 0) / total) * 100);
    };

    //获取指定星级数量
    const getRatingCount = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      return map[star] || 0;
    };

    //格式化时间
    const formatTime = (time) => {
      if (!time) return "";
      return new Date(time).toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    return {
      state,
      formDom,
      notice,
      onSubmit,
      onUploadChange,
      onDelTp,
      onPreviewTp,
      closePreview,
      onTabsChange,
      onLoadTc,
      openMapModal,
      pagedPjList,
      loadPingJia,
      getRatingPercent,
      getRatingCount,
      formatTime,
      getImageUrl,
      loadUploadConfig,
      Check,
      Clock,
      Delete,
      Plus,
      View,
    };
  },
};
</script>
<style scoped>
.detailBox {
  height: 100%;
  overflow-y: auto;
}

.baseInfoSection {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.baseInfoHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 14px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.baseInfoForm {
  margin-bottom: 0;
}

.formGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 0 16px;
}

.formGrid :deep(.el-form-item) {
  flex: 0 0 calc(33.333% - 11px);
  margin-right: 0;
  margin-bottom: 14px;
}

.formGrid :deep(.el-form-item .el-select),
.formGrid :deep(.el-form-item .el-input),
.formGrid :deep(.el-form-item .el-input-number) {
  width: 100%;
}

.formGrid :deep(.formItemGroup) {
  flex: 0 0 calc(33.333% - 11px);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.formGrid :deep(.formItemGroup .el-form-item) {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.formGrid :deep(.formItemGroup .formItemYuyueTianShu) {
  flex: 1;
}

.formItemFull {
  flex: 0 0 100% !important;
}

.moreCollapse {
  border: none;
}

.moreCollapse :deep(.el-collapse-item__header) {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  color: #909399;
  border: none;
  padding: 0 12px;
}

.moreCollapse :deep(.el-collapse-item__wrap) {
  border: none;
}

.moreCollapse :deep(.el-collapse-item__content) {
  padding: 8px 0 0 0;
}

.tabSection {
  background: #fff;
  border-radius: 8px;
  padding: 0 24px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.tabSection :deep(.el-tabs__header) {
  margin-bottom: 0;
}

.mapContainer {
  height: 480px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  display: flex;
  color: #a2a2a2;
  &:hover {
    background-color: rgba(100, 100, 100, 0.2) !important;
    color: #fff !important;
  }
}

.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  color: #fff;
  display: none;
}
.uploadActions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 12px;
  box-sizing: border-box;
}
.actionIcon {
  cursor: pointer;
  transition: transform 0.2s;
}
.actionIcon:hover {
  transform: scale(1.15);
}

.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.uploadTpBox:hover .uploadDel {
  display: flex !important;
}

/* ===== 评价信息 ===== */
.pjWrap {
  padding: 10px 0;
}

.pjSummary {
  display: flex;
  gap: 40px;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;
  align-items: center;
}

.pjScoreBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.pjScore {
  font-size: 42px;
  font-weight: 700;
  color: #ff9900;
  line-height: 1;
}

.pjUnit {
  font-size: 18px;
  color: #999;
  margin-bottom: 6px;
}

.pjStars {
  margin: 4px 0;
}

.pjTotal {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}

.pjDist {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pjDistItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pjDistLabel {
  font-size: 13px;
  color: #666;
  width: 30px;
  text-align: right;
}

.pjDistCount {
  font-size: 13px;
  color: #999;
  width: 28px;
}

.pjList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pjItem {
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pjHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pjUser {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pjTime {
  font-size: 12px;
  color: #bbb;
  margin-left: auto;
}

.pjTags {
  margin-bottom: 8px;
}

.pjContent {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pjImages {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.pjImg {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.pjReply {
  margin-top: 12px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 6px;
}

.pjReplyHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.pjReplyLabel {
  font-size: 12px;
  color: #409eff;
  font-weight: 500;
}

.pjReplyTime {
  font-size: 12px;
  color: #bbb;
}

.pjReplyContent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  white-space: pre-wrap;
}

.pjEmpty {
  padding: 40px 0;
}

/* ===== 使用须知编辑器 ===== */
.notice-editor {
  padding: 16px 8px;
}

.notice-section {
  margin-bottom: 28px;
}

.notice-section:last-child {
  margin-bottom: 0;
}

.notice-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.notice-section-title .el-icon {
  font-size: 18px;
  color: #409eff;
}

.notice-section-title .el-button {
  margin-left: auto;
}

.notice-empty {
  padding: 20px 0;
  text-align: center;
  font-size: 13px;
  color: #999;
  background: #fafbfc;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  margin-top: 8px;
}
</style>
